import { Col, Row, Typography } from "antd";
import React from "react";
import maintenance from "./assets/Images/maintenance.svg";

const Maintenance = () => {
  return (
    <Row className="form-error-page">
      <Col className="form-error-page-content">
        <img src={maintenance} alt="" />
        <Typography.Text className="form-error-page-title">
          We are under scheduled maintenance!
        </Typography.Text>
        <Typography.Text className="form-error-page-text">
          Please come back later. Thank you for your patience.
        </Typography.Text>
      </Col>
    </Row>
  );
};

export default Maintenance;
